import { request, IPaginationData, IPaginationQuery } from './base';
import {
  INewsletter,
  ICreateNewsletterRequest,
  ENewsletterType,
} from '../models/newsletter.model';

interface INewsletterListQuery extends IPaginationQuery {
  newsletter_type?: ENewsletterType;
  sort_by?: string;
  order?: 'ASC' | 'DESC';
  keyword?: string;
}

class NewsletterApi {
  getList(query: INewsletterListQuery) {
    return request<IPaginationData<INewsletter>>({
      method: 'GET',
      url: '/newsletter',
      params: query,
    });
  }

  getById(id: string) {
    return request<INewsletter>({
      method: 'GET',
      url: `/newsletter/${id}`,
    });
  }

  create(data: ICreateNewsletterRequest) {
    return request<INewsletter>({
      method: 'POST',
      url: '/newsletter',
      data,
    });
  }

}

export default new NewsletterApi();
